import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import useApplication from '../contexts/Application';
import useAnswer from '../contexts/Answer';
import Clock from './Clock';
import QuestionChoice from './QuestionChoice';
import QuestionRecord from './QuestionRecord';


const Box = styled.div`
  .title {
    display: flex;
    margin: 0;
    justify-content: space-between;
      align-items: center;

    h1 {
      margin: 0;
    }
  }

  > hr {
    margin: 2rem 0 0 0;
    height: 10px;
    border: 0;
    border-radius: 4px;
    background-color: ${props => props.theme.colors.smoke};
    background-image: linear-gradient(90deg, ${props => props.theme.colors.blue} 0%, ${props => props.theme.colors.blue} ${props => props.$percentage}%, ${props => props.theme.colors.smoke} ${props => props.$percentage}%, ${props => props.theme.colors.smoke} 100%);
  }

  > button {
    position: fixed;
    top: calc(5vh + 20rem);
    left: calc(50vw + 400px + 2rem);
  }
`;


const Answer = () => {
  const { application } = useApplication();
  const { answer, nextAnswer } = useAnswer();

  const [started, start] = useState(null);
  const [stopped, stop] = useState(false);
  const [timeout, setTimeout] = useState(false);
  const [fetching, setFetch] = useState(false);
  const [paused, setPause] = useState(false);

  useEffect(
    () => {
      if (!answer) {
        return;
      }
      start(new Date());
      stop(false);
      setTimeout(false);
      setFetch(false);
      setPause(false);
    },
    [answer],
  );

  const handleNextQuestion = () => {
    setFetch(true);
    nextAnswer({}, paused);
  };

  const handlePause = () => {
    setPause(true);
  };

  const handleTimeout = useCallback(() => {
    setPause(false);
    setTimeout(true);
  }, []);

  const handleAnswered = useCallback((values) => {
    stop(true);
    setFetch(true);
    nextAnswer(values, paused);
  }, [nextAnswer, paused]);

  return (
    <>
      {answer && answer.question && (
        <Box $percentage={answer.progress}>
          {started && (<Clock started={started} stopped={stopped} limit={answer.question.timeLimit} onTimeout={handleTimeout} />)}
          {timeout && !fetching && (<button className="primary" onClick={handleNextQuestion}>Next Question</button>)}
          {timeout && fetching && (<button className="primary disabled">Next Question</button>)}
          {answer.remaining > 1 && !stopped && !timeout && !paused && (<button onClick={handlePause}>I need a break!</button>)}
          {answer.remaining > 1 && !stopped && !timeout && paused && (<button className="plain disabled">The assesment will be paused after this question.</button>)}
          <div className="title">
            <h1>{application.assessment.title}</h1>
            {answer.remaining > 0 && (<span>Approximately {answer.remaining} question{answer.remaining === 1 ? '' : 's'} remaining</span>)}
            {answer.remaining === 0 && (<span>Last question.</span>)}
          </div>
          <hr />
          {answer.question.type === 'CHOICE' && (<QuestionChoice question={answer.question} timeout={timeout} stopped={stopped} onAnswered={handleAnswered} />)}
          {answer.question.type === 'RECORD' && (<QuestionRecord question={answer.question} timeout={timeout} stopped={stopped} onAnswered={handleAnswered} />)}
        </Box>
      )}
    </>
  );
};

export default Answer;
